import Honeybadger from '@honeybadger-io/js';
import { getBootstrapData } from '$shared/utils.js';

if (!window.TMPDisableErrorTracking) {
  Honeybadger.configure({
    api_key: getBootstrapData('honeybadgerKey'),
    environment: getBootstrapData('env'),
  });
}
